import React from 'react';
import parser from 'react-html-parser';

import { latexParser } from '../../../utilities/utilities';

import classes from './Person.module.scss';

const Person = props => {
    return <div className={classes.Person}>
        <h3>{props.firstName} {props.lastName}, {props.affiliation}</h3>
        <div className={classes.Info}>{parser(props.info)}</div>
        {props.title && <div className={props.title ? classes.Talk : classes.NoTalk}>
            <div className={classes.Title}>Talk title: {latexParser(props.title)}</div>
            <div className={classes.Abstract}>{latexParser(props.abstract)}</div>
        </div>}

    </div>
}

export default Person;